import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { MaintenanceStateInfo } from '@mp/system/maintenance/domain';

@Injectable()
export class MaintenanceStateService {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = '/api/kernel/maintenance/state';

  /**
   * Fetches the maintenance state for the current login from the backend.
   *
   * The endpoint stays reachable while the maintenance lock is active.
   * @returns The current maintenance state.
   */
  getMaintenanceState(): Observable<MaintenanceStateInfo> {
    return this.http.get<MaintenanceStateInfo>(this.baseUrl);
  }
}
